import { Pipe, PipeTransform } from '@angular/core';
import { ApprovalConstants } from '../../Common/Constants/data';

@Pipe({
  name: 'getApprovalStageColor'
})
export class GetApprovalStageColorPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value) {
      return 'transparent'; // Default color if value is null or undefined
    }

    switch (value) {
      case ApprovalConstants.Approval_RequestForReview:
        return 'text-warning';
      case ApprovalConstants.Approval_Approved:
        return 'text-success';
      case ApprovalConstants.Approval_ACTIONREQUIRED:
        return 'text-danger'; // Bootstrap class for red text
      case ApprovalConstants.Approval_LOCKED:
        return 'lockedText'; // Custom class, you'll need to define this in your CSS
      case ApprovalConstants.Approval_UNLOCKED:
        return 'unlockedText'; // Bootstrap class for blue text
      default:
        return ''; // Default class if no match found 
    }
  }

}
